/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_shipment = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_shipment">;
    readonly " $refType": "PdpSharedDetailShipping_shipment";
};
export type PdpSharedDetailShipping_shipment$data = PdpSharedDetailShipping_shipment;
export type PdpSharedDetailShipping_shipment$key = {
    readonly " $data"?: PdpSharedDetailShipping_shipment$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_shipment">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_shipment",
      "args": null
    }
  ]
};
(node as any).hash = 'e9f3329434df464231cc9695b4dad2f4';
export default node;
